import { render, staticRenderFns } from "./DataSets.vue?vue&type=template&id=6378f420&scoped=true&"
import script from "./DataSets.vue?vue&type=script&lang=ts&"
export * from "./DataSets.vue?vue&type=script&lang=ts&"
import style0 from "./DataSets.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DataSets.vue?vue&type=style&index=1&id=6378f420&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6378f420",
  null
  
)

export default component.exports